#import "../plannedBreak/plannedBreakInfo.gql"

fragment lineInfo on Line {
  efficiency
  id
  name
  lineType
  active
}
